import { LambdaResponsePayload } from "@pages/Article/types/Alacrity";

import ArticleSubshareGiftingUpdateContent from "./ArticleSubshareGiftingUpdateContent";
import ArticleSubshareModal from "./ArticleSubshareModal";

type ArticleSubshareGiftingUpdateProps = {
  alacrityRes?: LambdaResponsePayload;
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setShowGiftSent: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function ArticleSubshareGiftingUpdate({
  isModalOpen,
  setIsModalOpen,
  setShowGiftSent,
}: ArticleSubshareGiftingUpdateProps): React.ReactElement {
  return (
    <div data-testid="article-subshare-gifting-update-component">
      <ArticleSubshareModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        isContentCentered={false}
      >
        <ArticleSubshareGiftingUpdateContent
          setIsModalOpen={setIsModalOpen}
          setShowGiftSent={setShowGiftSent}
        />
      </ArticleSubshareModal>
    </div>
  );
}
